/** The type of the communication channel */
export var ChannelType;
(function (ChannelType) {
    ChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["SMS"] = "SMS";
})(ChannelType || (ChannelType = {}));
export var AcceptedDirectMessageType;
(function (AcceptedDirectMessageType) {
    AcceptedDirectMessageType["TEXT"] = "TEXT";
    AcceptedDirectMessageType["MEDIA"] = "MEDIA";
    AcceptedDirectMessageType["CARD"] = "CARD";
    AcceptedDirectMessageType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    AcceptedDirectMessageType["FORM"] = "FORM";
})(AcceptedDirectMessageType || (AcceptedDirectMessageType = {}));
/** Mime type for relevant media entities in channels */
export var MediaMimeType;
(function (MediaMimeType) {
    MediaMimeType["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
    MediaMimeType["IMAGE_JPEG"] = "IMAGE_JPEG";
    MediaMimeType["IMAGE_PNG"] = "IMAGE_PNG";
    MediaMimeType["IMAGE_WEBP"] = "IMAGE_WEBP";
    MediaMimeType["VIDEO_MPEG"] = "VIDEO_MPEG";
    MediaMimeType["VIDEO_MP4"] = "VIDEO_MP4";
    MediaMimeType["VIDEO_3GP"] = "VIDEO_3GP";
    MediaMimeType["AUDIO_AAC"] = "AUDIO_AAC";
    MediaMimeType["AUDIO_MP4"] = "AUDIO_MP4";
    MediaMimeType["AUDIO_MPEG"] = "AUDIO_MPEG";
    MediaMimeType["AUDIO_OGG"] = "AUDIO_OGG";
    MediaMimeType["AUDIO_OPUS"] = "AUDIO_OPUS";
    MediaMimeType["APPLICATION_PDF"] = "APPLICATION_PDF";
    MediaMimeType["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(MediaMimeType || (MediaMimeType = {}));
export var AcceptedSmsMessageType;
(function (AcceptedSmsMessageType) {
    AcceptedSmsMessageType["SMS"] = "SMS";
    AcceptedSmsMessageType["MMS"] = "MMS";
})(AcceptedSmsMessageType || (AcceptedSmsMessageType = {}));
export var InitDirection;
(function (InitDirection) {
    InitDirection["UNKNOWN_INIT_DIRECTION"] = "UNKNOWN_INIT_DIRECTION";
    InitDirection["BUSINESS"] = "BUSINESS";
    InitDirection["CUSTOMER"] = "CUSTOMER";
    InitDirection["BOTH"] = "BOTH";
})(InitDirection || (InitDirection = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["UNKNOWN_CONNECTION_STATE"] = "UNKNOWN_CONNECTION_STATE";
    ConnectionStatus["VALID"] = "VALID";
    ConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
    ConnectionStatus["INVALID"] = "INVALID";
    ConnectionStatus["PENDING"] = "PENDING";
    ConnectionStatus["SUSPENDED"] = "SUSPENDED";
})(ConnectionStatus || (ConnectionStatus = {}));
/** Determines the cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var MessageType;
(function (MessageType) {
    MessageType["UNKNOWN_MESSAGE_TYPE"] = "UNKNOWN_MESSAGE_TYPE";
    MessageType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    MessageType["EMAIL"] = "EMAIL";
    MessageType["SMS"] = "SMS";
})(MessageType || (MessageType = {}));
export var PayloadType;
(function (PayloadType) {
    PayloadType["UNKNOWN_MESSAGE_TYPE"] = "UNKNOWN_MESSAGE_TYPE";
    PayloadType["SIMPLE_TEXT"] = "SIMPLE_TEXT";
    PayloadType["SIMPLE_MEDIA"] = "SIMPLE_MEDIA";
    PayloadType["SIMPLE_LOCATION"] = "SIMPLE_LOCATION";
    PayloadType["CARD"] = "CARD";
    PayloadType["CONTACT"] = "CONTACT";
    PayloadType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    PayloadType["FORM"] = "FORM";
    PayloadType["ACTIONABLE_FORM"] = "ACTIONABLE_FORM";
})(PayloadType || (PayloadType = {}));
export var TextMimeType;
(function (TextMimeType) {
    TextMimeType["TEXT_PLAIN"] = "TEXT_PLAIN";
})(TextMimeType || (TextMimeType = {}));
export var Orientation;
(function (Orientation) {
    Orientation["PORTRAIT"] = "PORTRAIT";
    Orientation["LANDSCAPE"] = "LANDSCAPE";
})(Orientation || (Orientation = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["CTA"] = "CTA";
    ButtonType["POSTBACK"] = "POSTBACK";
    ButtonType["POSTBACK_AND_CTA"] = "POSTBACK_AND_CTA";
})(ButtonType || (ButtonType = {}));
export var AttachmentDisposition;
(function (AttachmentDisposition) {
    AttachmentDisposition["ATTACHMENT"] = "ATTACHMENT";
    AttachmentDisposition["INLINE"] = "INLINE";
})(AttachmentDisposition || (AttachmentDisposition = {}));
export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["UNKNOWN_MESSAGE_DIRECTION"] = "UNKNOWN_MESSAGE_DIRECTION";
    MessageDirection["TO_BUSINESS"] = "TO_BUSINESS";
    MessageDirection["FROM_BUSINESS"] = "FROM_BUSINESS";
})(MessageDirection || (MessageDirection = {}));
export var StatusType;
(function (StatusType) {
    StatusType["UNKNOWN_STATUS_TYPE"] = "UNKNOWN_STATUS_TYPE";
    StatusType["SENT"] = "SENT";
    StatusType["DELIVERED"] = "DELIVERED";
    StatusType["SEEN"] = "SEEN";
    StatusType["FAILED"] = "FAILED";
    StatusType["DELETED"] = "DELETED";
})(StatusType || (StatusType = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["UNKNOWN_FAILED_CODE"] = "UNKNOWN_FAILED_CODE";
    ErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    ErrorCode["MISSING_PERMISSION"] = "MISSING_PERMISSION";
    /** RATE_LIMIT_EXCEEDED */
    ErrorCode["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    ErrorCode["QUOTA_EXCEEDED"] = "QUOTA_EXCEEDED";
    ErrorCode["INVALID_PARAMETER"] = "INVALID_PARAMETER";
    ErrorCode["EXPIRED_ACCESS_TOKEN"] = "EXPIRED_ACCESS_TOKEN";
    ErrorCode["POLICY_VIOLATION"] = "POLICY_VIOLATION";
    ErrorCode["BLOCKED"] = "BLOCKED";
    ErrorCode["MESSAGE_EXPIRED"] = "MESSAGE_EXPIRED";
    ErrorCode["GENERIC_ERROR"] = "GENERIC_ERROR";
    ErrorCode["UNSUPPORTED_MESSAGE_TYPE"] = "UNSUPPORTED_MESSAGE_TYPE";
    ErrorCode["BACKEND_ERROR"] = "BACKEND_ERROR";
})(ErrorCode || (ErrorCode = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN_SUBSCRIPTION_STATUS"] = "UNKNOWN_SUBSCRIPTION_STATUS";
    SubscriptionStatus["SUBSCRIBED"] = "SUBSCRIBED";
    SubscriptionStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CanSendInfoType;
(function (CanSendInfoType) {
    CanSendInfoType["UNKNOWN_ADDITIONAL_INFO_TYPE"] = "UNKNOWN_ADDITIONAL_INFO_TYPE";
    CanSendInfoType["RECIPIENT_UNSUBSCRIBED"] = "RECIPIENT_UNSUBSCRIBED";
    CanSendInfoType["RECIPIENT_BLOCKED"] = "RECIPIENT_BLOCKED";
    CanSendInfoType["INVALID_RECIPIENT"] = "INVALID_RECIPIENT";
    CanSendInfoType["ADDITIONAL_ACTION_REQUIRED"] = "ADDITIONAL_ACTION_REQUIRED";
    CanSendInfoType["QUOTA_EXCEEDED"] = "QUOTA_EXCEEDED";
    CanSendInfoType["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    CanSendInfoType["ACCOUNT_CONNECTION_NOT_ACTIVE"] = "ACCOUNT_CONNECTION_NOT_ACTIVE";
})(CanSendInfoType || (CanSendInfoType = {}));
export var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
})(RuleType || (RuleType = {}));
//# sourceMappingURL=types.impl.js.map